import React, { Component } from "react";
import firebase from "firebase";
// import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite";
import { Glyphicon } from "react-bootstrap";
import { connect } from "react-redux";
import { PromoChange } from "../../redux/actions/modal";
import ModalEditarPerfil from "../modalEditarPefil";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
class Nav2 extends Component {
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
      authDomain: "tourbrazil-41fbe.firebaseapp.com",
      databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
      projectId: "tourbrazil-41fbe",
      storageBucket: "tourbrazil-41fbe.appspot.com",
      messagingSenderId: "927605208400"
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
  }
  sair() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        window.location = "/";
      })
      .catch(error => {
        console.log(error);
      });
  }
  render() {
    return (
      <div>
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span className="sr-only">Navegação</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>

          <a className="navbar-brand" href="#">
            <p>
              {" "}
              Painel - {this.props.user ? this.props.user.nome : "Usuario"}
            </p>
          </a>
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav">
            <li className="active">
              <a href="/home">
                <Glyphicon className={css(styles.icones)} glyph="equalizer" />{" "}
                Painel Geral <span className="sr-only">(current)</span>
              </a>
            </li>

            <li>
              <a
                className={css(styles.item)}
                alt="Criar Promoção"
                onClick={() => this.props.PromoChange(true)}
              >
                <Glyphicon className={css(styles.icones)} glyph="heart-empty" />{" "}
                Criar Promoção
              </a>
            </li>
          </ul>

          <ul className="nav navbar-nav navbar-right">
            <li className="dropdown">
              <a
                href="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Glyphicon className={css(styles.icones)} glyph="cog" /> Opções{" "}
                <span className="caret" />
              </a>

              <ul className="dropdown-menu">
                <li>
                  <a className={css(styles.item)}>
                    <ModalEditarPerfil />
                  </a>
                </li>
                <li>
                  <a
                    className={css(styles.item)}
                    alt="Sair"
                    onClick={() => this.sair()}
                  >
                    <Glyphicon className={css(styles.icones)} glyph="off" />{" "}
                    Sair
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  menu: {
    background: "#2e323a"
  },
  profileTitle: {
    color: "#fff",
    fontSize: "25px",
    margin: "0 auto",
    textAlign: "center",
    marginBottom: "10px"
  },
  profileTitle2: {
    color: "#fff",
    fontSize: "20px",
    margin: "0 auto",
    textAlign: "center"
  },
  item: {
    cursor: "pointer"
  },
  icones: {
    fontSize: "18px",
    verticalAlign: "sub",
    marginRight: "3px"
  }
});

const mapStateToProps = state => {
  return {
    user: state.user.user
  };
};
export default connect(
  mapStateToProps,
  { PromoChange }
)(Nav2);



// WEBPACK FOOTER //
// ./src/assets/navBar/index.js